export default __webpack_public_path__ + "static/media/diseño.930f451a.png";